/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TB License Platform API
 * Lean v1 controlled-pilot contract. One active Product Key allocates one
 * seat and may authorize at most one active Activation. Product Keys and
 * Activation Secrets are write-only delivery credentials and never appear in
 * admin read responses.
 *
 * OpenAPI spec version: 1.1.0
 */
import type {
  APIActivityExportRequest,
  APIActivityFilters,
  ActivationListResponse,
  ActivationRecordResponse,
  ActivationsResponse,
  AdminAccountEnrollmentResponse,
  AdminAccountListResponse,
  AdminAccountResponse,
  AuditExportRequest,
  AuditResponse,
  BadRequestResponse,
  BulkActivationMutationRequest,
  BulkActivationMutationResponse,
  ConflictResponse,
  CreateAdminAccountRequest,
  CurrentIdentityResponse,
  CustomerListResponse,
  CustomerRequest,
  CustomerResponse,
  DeliveryPackExportRequest,
  DeliveryPackExportResponse,
  DeliveryPackPDFRequest,
  ErrorResponse,
  ForbiddenResponse,
  GetAPIActivity200,
  GetAPIActivityParams,
  GetAPIActivitySettings200,
  GetProductAppVersionDistributionParams,
  GetProductLifecycleTrendParams,
  GetProductPlatformDistributionParams,
  GetProductUsageSnapshotParams,
  KeyBatchRequest,
  KeyBatchResponse,
  LicenseListResponse,
  LicensePatchRequest,
  LicenseRequest,
  LicenseResponse,
  ListAPIActivity200,
  ListAPIActivityParams,
  ListActivationsParams,
  ListAllActivationsParams,
  ListAllProductKeysParams,
  ListAuditEventsParams,
  ListLicenseTimelineParams,
  ListLicensesParams,
  ListProductKeysParams,
  NotFoundResponse,
  ProductAppVersionDistributionResponse,
  ProductFeatureCatalogRequest,
  ProductKeyReplacementResponse,
  ProductKeyResponse,
  ProductKeysResponse,
  ProductLifecycleTrendResponse,
  ProductListResponse,
  ProductPlatformDistributionResponse,
  ProductRequest,
  ProductResponse,
  ProductStatusRequest,
  ProductUsageSnapshotResponse,
  PromoteLicenseRequest,
  ReasonRequest,
  SearchAPIActivity200,
  SearchAdminEntitiesParams,
  SearchResponse,
  SeatLimitReductionRequest,
  ServiceUnavailableResponse,
  TimelineResponse,
  TooManyRequestsResponse,
  UnauthorizedResponse,
  UpdateAPIActivitySettings200,
  UpdateAPIActivitySettingsRequest,
  UpdateAdminAccountRoleRequest,
  UpdateAdminAccountStateRequest
} from './model';

import { adminFetch } from './mutator';

export type getAPIActivitySettingsResponse200 = {
  data: GetAPIActivitySettings200
  status: 200
}

export type getAPIActivitySettingsResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type getAPIActivitySettingsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type getAPIActivitySettingsResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type getAPIActivitySettingsResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type getAPIActivitySettingsResponseSuccess = (getAPIActivitySettingsResponse200) & {
  headers: Headers;
};
export type getAPIActivitySettingsResponseError = (getAPIActivitySettingsResponse400 | getAPIActivitySettingsResponse401 | getAPIActivitySettingsResponse403 | getAPIActivitySettingsResponse503) & {
  headers: Headers;
};

export type getAPIActivitySettingsResponse = (getAPIActivitySettingsResponseSuccess | getAPIActivitySettingsResponseError)

export const getGetAPIActivitySettingsUrl = () => {

  return `/v1/admin/api-activity/settings`
}

/**
 * @summary Security Admin-only API Activity settings
 */
export const getAPIActivitySettings = async ( options?: RequestInit): Promise<getAPIActivitySettingsResponse> => {

  return adminFetch<getAPIActivitySettingsResponse>(getGetAPIActivitySettingsUrl(),
  {
    ...options,
    method: 'GET'

  }
);}

export type updateAPIActivitySettingsResponse200 = {
  data: UpdateAPIActivitySettings200
  status: 200
}

export type updateAPIActivitySettingsResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type updateAPIActivitySettingsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type updateAPIActivitySettingsResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type updateAPIActivitySettingsResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type updateAPIActivitySettingsResponseSuccess = (updateAPIActivitySettingsResponse200) & {
  headers: Headers;
};
export type updateAPIActivitySettingsResponseError = (updateAPIActivitySettingsResponse400 | updateAPIActivitySettingsResponse401 | updateAPIActivitySettingsResponse403 | updateAPIActivitySettingsResponse503) & {
  headers: Headers;
};

export type updateAPIActivitySettingsResponse = (updateAPIActivitySettingsResponseSuccess | updateAPIActivitySettingsResponseError)

export const getUpdateAPIActivitySettingsUrl = () => {

  return `/v1/admin/api-activity/settings`
}

/**
 * @summary Security Admin-only API Activity settings update
 */
export const updateAPIActivitySettings = async (updateAPIActivitySettingsRequest: UpdateAPIActivitySettingsRequest, options?: RequestInit): Promise<updateAPIActivitySettingsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<updateAPIActivitySettingsResponse>(getUpdateAPIActivitySettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAPIActivitySettingsRequest)
  }
);}

export type exportAPIActivityResponse200TextCsv = {
  data: Blob
  status: 200
}

export type exportAPIActivityResponse200ApplicationJson = {
  data: Blob
  status: 200
}

export type exportAPIActivityResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type exportAPIActivityResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type exportAPIActivityResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type exportAPIActivityResponse409 = {
  data: ConflictResponse
  status: 409
}

export type exportAPIActivityResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type exportAPIActivityResponseSuccess = (exportAPIActivityResponse200TextCsv | exportAPIActivityResponse200ApplicationJson) & {
  headers: Headers;
};
export type exportAPIActivityResponseError = (exportAPIActivityResponse400 | exportAPIActivityResponse401 | exportAPIActivityResponse403 | exportAPIActivityResponse409 | exportAPIActivityResponse503) & {
  headers: Headers;
};

export type exportAPIActivityResponse = (exportAPIActivityResponseSuccess | exportAPIActivityResponseError)

export const getExportAPIActivityUrl = () => {

  return `/v1/admin/api-activity/export`
}

/**
 * IP membership expiring during audit returns 409 activity_ip_association_expired without bytes. Export audit bytes describe the pre-release snapshot, not delivery.
 * @summary Security Admin-only API Activity filtered export
 */
export const exportAPIActivity = async (aPIActivityExportRequest: APIActivityExportRequest, options?: RequestInit): Promise<exportAPIActivityResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<exportAPIActivityResponse>(getExportAPIActivityUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(aPIActivityExportRequest)
  }
);}

export type searchAPIActivityResponse200 = {
  data: SearchAPIActivity200
  status: 200
}

export type searchAPIActivityResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type searchAPIActivityResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type searchAPIActivityResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type searchAPIActivityResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type searchAPIActivityResponse409 = {
  data: ConflictResponse
  status: 409
}

export type searchAPIActivityResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type searchAPIActivityResponseSuccess = (searchAPIActivityResponse200) & {
  headers: Headers;
};
export type searchAPIActivityResponseError = (searchAPIActivityResponse400 | searchAPIActivityResponse401 | searchAPIActivityResponse403 | searchAPIActivityResponse404 | searchAPIActivityResponse409 | searchAPIActivityResponse503) & {
  headers: Headers;
};

export type searchAPIActivityResponse = (searchAPIActivityResponseSuccess | searchAPIActivityResponseError)

export const getSearchAPIActivityUrl = () => {

  return `/v1/admin/api-activity/search`
}

/**
 * IP membership expiring during audit returns 409 activity_ip_association_expired; clear the IP filter before searching again.
 * @summary Security Admin exact protected IP search; audited before matches are released
 */
export const searchAPIActivity = async (aPIActivityFilters: APIActivityFilters, options?: RequestInit): Promise<searchAPIActivityResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<searchAPIActivityResponse>(getSearchAPIActivityUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(aPIActivityFilters)
  }
);}

export type listAPIActivityResponse200 = {
  data: ListAPIActivity200
  status: 200
}

export type listAPIActivityResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type listAPIActivityResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type listAPIActivityResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type listAPIActivityResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type listAPIActivityResponse409 = {
  data: ConflictResponse
  status: 409
}

export type listAPIActivityResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type listAPIActivityResponseSuccess = (listAPIActivityResponse200) & {
  headers: Headers;
};
export type listAPIActivityResponseError = (listAPIActivityResponse400 | listAPIActivityResponse401 | listAPIActivityResponse403 | listAPIActivityResponse404 | listAPIActivityResponse409 | listAPIActivityResponse503) & {
  headers: Headers;
};

export type listAPIActivityResponse = (listAPIActivityResponseSuccess | listAPIActivityResponseError)

export const getListAPIActivityUrl = (params?: ListAPIActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/api-activity?${stringifiedParams}` : `/v1/admin/api-activity`
}

/**
 * @summary Security Admin-only API Activity list
 */
export const listAPIActivity = async (params?: ListAPIActivityParams, options?: RequestInit): Promise<listAPIActivityResponse> => {

  return adminFetch<listAPIActivityResponse>(getListAPIActivityUrl(params),
  {
    ...options,
    method: 'GET'

  }
);}

export type getAPIActivityResponse200 = {
  data: GetAPIActivity200
  status: 200
}

export type getAPIActivityResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type getAPIActivityResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type getAPIActivityResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type getAPIActivityResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type getAPIActivityResponse409 = {
  data: ConflictResponse
  status: 409
}

export type getAPIActivityResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type getAPIActivityResponseSuccess = (getAPIActivityResponse200) & {
  headers: Headers;
};
export type getAPIActivityResponseError = (getAPIActivityResponse400 | getAPIActivityResponse401 | getAPIActivityResponse403 | getAPIActivityResponse404 | getAPIActivityResponse409 | getAPIActivityResponse503) & {
  headers: Headers;
};

export type getAPIActivityResponse = (getAPIActivityResponseSuccess | getAPIActivityResponseError)

export const getGetAPIActivityUrl = (eventId: string,
    params?: GetAPIActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/api-activity/${eventId}?${stringifiedParams}` : `/v1/admin/api-activity/${eventId}`
}

/**
 * @summary Security Admin-only API Activity detail
 */
export const getAPIActivity = async (eventId: string,
    params?: GetAPIActivityParams, options?: RequestInit): Promise<getAPIActivityResponse> => {

  return adminFetch<getAPIActivityResponse>(getGetAPIActivityUrl(eventId,params),
  {
    ...options,
    method: 'GET'

  }
);}

export type listAllActivationsResponse200 = {
  data: ActivationListResponse
  status: 200
}

export type listAllActivationsResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type listAllActivationsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type listAllActivationsResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type listAllActivationsResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type listAllActivationsResponseSuccess = (listAllActivationsResponse200) & {
  headers: Headers;
};
export type listAllActivationsResponseError = (listAllActivationsResponse400 | listAllActivationsResponse401 | listAllActivationsResponse403 | listAllActivationsResponse503) & {
  headers: Headers;
};

export type listAllActivationsResponse = (listAllActivationsResponseSuccess | listAllActivationsResponseError)

export const getListAllActivationsUrl = (params?: ListAllActivationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/activations?${stringifiedParams}` : `/v1/activations`
}

export const listAllActivations = async (params?: ListAllActivationsParams, options?: RequestInit): Promise<listAllActivationsResponse> => {

  return adminFetch<listAllActivationsResponse>(getListAllActivationsUrl(params),
  {
    ...options,
    method: 'GET'

  }
);}

export type listAllProductKeysResponse200 = {
  data: ProductKeysResponse
  status: 200
}

export type listAllProductKeysResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type listAllProductKeysResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type listAllProductKeysResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type listAllProductKeysResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type listAllProductKeysResponseSuccess = (listAllProductKeysResponse200) & {
  headers: Headers;
};
export type listAllProductKeysResponseError = (listAllProductKeysResponse400 | listAllProductKeysResponse401 | listAllProductKeysResponse403 | listAllProductKeysResponse503) & {
  headers: Headers;
};

export type listAllProductKeysResponse = (listAllProductKeysResponseSuccess | listAllProductKeysResponseError)

export const getListAllProductKeysUrl = (params?: ListAllProductKeysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/product-keys?${stringifiedParams}` : `/v1/product-keys`
}

export const listAllProductKeys = async (params?: ListAllProductKeysParams, options?: RequestInit): Promise<listAllProductKeysResponse> => {

  return adminFetch<listAllProductKeysResponse>(getListAllProductKeysUrl(params),
  {
    ...options,
    method: 'GET'

  }
);}

export type currentAdminIdentityResponse200 = {
  data: CurrentIdentityResponse
  status: 200
}

export type currentAdminIdentityResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type currentAdminIdentityResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type currentAdminIdentityResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type currentAdminIdentityResponseSuccess = (currentAdminIdentityResponse200) & {
  headers: Headers;
};
export type currentAdminIdentityResponseError = (currentAdminIdentityResponse401 | currentAdminIdentityResponse403 | currentAdminIdentityResponse503) & {
  headers: Headers;
};

export type currentAdminIdentityResponse = (currentAdminIdentityResponseSuccess | currentAdminIdentityResponseError)

export const getCurrentAdminIdentityUrl = () => {

  return `/v1/admin/me`
}

export const currentAdminIdentity = async ( options?: RequestInit): Promise<currentAdminIdentityResponse> => {

  return adminFetch<currentAdminIdentityResponse>(getCurrentAdminIdentityUrl(),
  {
    ...options,
    method: 'GET'

  }
);}

export type listAdminAccountsResponse200 = {
  data: AdminAccountListResponse
  status: 200
}

export type listAdminAccountsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type listAdminAccountsResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type listAdminAccountsResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type listAdminAccountsResponseSuccess = (listAdminAccountsResponse200) & {
  headers: Headers;
};
export type listAdminAccountsResponseError = (listAdminAccountsResponse401 | listAdminAccountsResponse403 | listAdminAccountsResponse503) & {
  headers: Headers;
};

export type listAdminAccountsResponse = (listAdminAccountsResponseSuccess | listAdminAccountsResponseError)

export const getListAdminAccountsUrl = () => {

  return `/v1/admin/accounts`
}

export const listAdminAccounts = async ( options?: RequestInit): Promise<listAdminAccountsResponse> => {

  return adminFetch<listAdminAccountsResponse>(getListAdminAccountsUrl(),
  {
    ...options,
    method: 'GET'

  }
);}

export type createAdminAccountResponse201 = {
  data: AdminAccountEnrollmentResponse
  status: 201
}

export type createAdminAccountResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type createAdminAccountResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type createAdminAccountResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type createAdminAccountResponse409 = {
  data: ConflictResponse
  status: 409
}

export type createAdminAccountResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type createAdminAccountResponseSuccess = (createAdminAccountResponse201) & {
  headers: Headers;
};
export type createAdminAccountResponseError = (createAdminAccountResponse400 | createAdminAccountResponse401 | createAdminAccountResponse403 | createAdminAccountResponse409 | createAdminAccountResponse503) & {
  headers: Headers;
};

export type createAdminAccountResponse = (createAdminAccountResponseSuccess | createAdminAccountResponseError)

export const getCreateAdminAccountUrl = () => {

  return `/v1/admin/accounts`
}

export const createAdminAccount = async (createAdminAccountRequest: CreateAdminAccountRequest, options?: RequestInit): Promise<createAdminAccountResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<createAdminAccountResponse>(getCreateAdminAccountUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createAdminAccountRequest)
  }
);}

export type updateAdminAccountStateResponse200 = {
  data: AdminAccountResponse
  status: 200
}

export type updateAdminAccountStateResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type updateAdminAccountStateResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type updateAdminAccountStateResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type updateAdminAccountStateResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type updateAdminAccountStateResponse409 = {
  data: ConflictResponse
  status: 409
}

export type updateAdminAccountStateResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type updateAdminAccountStateResponseSuccess = (updateAdminAccountStateResponse200) & {
  headers: Headers;
};
export type updateAdminAccountStateResponseError = (updateAdminAccountStateResponse400 | updateAdminAccountStateResponse401 | updateAdminAccountStateResponse403 | updateAdminAccountStateResponse404 | updateAdminAccountStateResponse409 | updateAdminAccountStateResponse503) & {
  headers: Headers;
};

export type updateAdminAccountStateResponse = (updateAdminAccountStateResponseSuccess | updateAdminAccountStateResponseError)

export const getUpdateAdminAccountStateUrl = (accountId: string,) => {

  return `/v1/admin/accounts/${accountId}/state`
}

export const updateAdminAccountState = async (accountId: string,
    updateAdminAccountStateRequest: UpdateAdminAccountStateRequest, options?: RequestInit): Promise<updateAdminAccountStateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<updateAdminAccountStateResponse>(getUpdateAdminAccountStateUrl(accountId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAdminAccountStateRequest)
  }
);}

export type updateAdminAccountRoleResponse200 = {
  data: AdminAccountResponse
  status: 200
}

export type updateAdminAccountRoleResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type updateAdminAccountRoleResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type updateAdminAccountRoleResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type updateAdminAccountRoleResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type updateAdminAccountRoleResponse409 = {
  data: ConflictResponse
  status: 409
}

export type updateAdminAccountRoleResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type updateAdminAccountRoleResponseSuccess = (updateAdminAccountRoleResponse200) & {
  headers: Headers;
};
export type updateAdminAccountRoleResponseError = (updateAdminAccountRoleResponse400 | updateAdminAccountRoleResponse401 | updateAdminAccountRoleResponse403 | updateAdminAccountRoleResponse404 | updateAdminAccountRoleResponse409 | updateAdminAccountRoleResponse503) & {
  headers: Headers;
};

export type updateAdminAccountRoleResponse = (updateAdminAccountRoleResponseSuccess | updateAdminAccountRoleResponseError)

export const getUpdateAdminAccountRoleUrl = (accountId: string,) => {

  return `/v1/admin/accounts/${accountId}/role`
}

export const updateAdminAccountRole = async (accountId: string,
    updateAdminAccountRoleRequest: UpdateAdminAccountRoleRequest, options?: RequestInit): Promise<updateAdminAccountRoleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<updateAdminAccountRoleResponse>(getUpdateAdminAccountRoleUrl(accountId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateAdminAccountRoleRequest)
  }
);}

export type resetAdminAccountCredentialsResponse200 = {
  data: AdminAccountEnrollmentResponse
  status: 200
}

export type resetAdminAccountCredentialsResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type resetAdminAccountCredentialsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type resetAdminAccountCredentialsResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type resetAdminAccountCredentialsResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type resetAdminAccountCredentialsResponse409 = {
  data: ConflictResponse
  status: 409
}

export type resetAdminAccountCredentialsResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type resetAdminAccountCredentialsResponseSuccess = (resetAdminAccountCredentialsResponse200) & {
  headers: Headers;
};
export type resetAdminAccountCredentialsResponseError = (resetAdminAccountCredentialsResponse400 | resetAdminAccountCredentialsResponse401 | resetAdminAccountCredentialsResponse403 | resetAdminAccountCredentialsResponse404 | resetAdminAccountCredentialsResponse409 | resetAdminAccountCredentialsResponse503) & {
  headers: Headers;
};

export type resetAdminAccountCredentialsResponse = (resetAdminAccountCredentialsResponseSuccess | resetAdminAccountCredentialsResponseError)

export const getResetAdminAccountCredentialsUrl = (accountId: string,) => {

  return `/v1/admin/accounts/${accountId}/enrollment-token`
}

export const resetAdminAccountCredentials = async (accountId: string,
    reasonRequest: ReasonRequest, options?: RequestInit): Promise<resetAdminAccountCredentialsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<resetAdminAccountCredentialsResponse>(getResetAdminAccountCredentialsUrl(accountId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reasonRequest)
  }
);}

export type adminDeactivateActivationResponse200 = {
  data: ActivationRecordResponse
  status: 200
}

export type adminDeactivateActivationResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type adminDeactivateActivationResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type adminDeactivateActivationResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type adminDeactivateActivationResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type adminDeactivateActivationResponse409 = {
  data: ConflictResponse
  status: 409
}

export type adminDeactivateActivationResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type adminDeactivateActivationResponseSuccess = (adminDeactivateActivationResponse200) & {
  headers: Headers;
};
export type adminDeactivateActivationResponseError = (adminDeactivateActivationResponse400 | adminDeactivateActivationResponse401 | adminDeactivateActivationResponse403 | adminDeactivateActivationResponse404 | adminDeactivateActivationResponse409 | adminDeactivateActivationResponse503) & {
  headers: Headers;
};

export type adminDeactivateActivationResponse = (adminDeactivateActivationResponseSuccess | adminDeactivateActivationResponseError)

export const getAdminDeactivateActivationUrl = (activationId: string,) => {

  return `/v1/admin/activations/${activationId}/deactivate`
}

/**
 * Deactivates an exact Activation as an administrative cleanup action. This remains available when the Product is disabled or the License is suspended or revoked. Activation Secrets, credentials, and raw fingerprints are never accepted or returned.
 */
export const adminDeactivateActivation = async (activationId: string,
    reasonRequest: ReasonRequest, options?: RequestInit): Promise<adminDeactivateActivationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<adminDeactivateActivationResponse>(getAdminDeactivateActivationUrl(activationId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reasonRequest)
  }
);}

export type bulkDeactivateActivationsResponse200 = {
  data: BulkActivationMutationResponse
  status: 200
}

export type bulkDeactivateActivationsResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type bulkDeactivateActivationsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type bulkDeactivateActivationsResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type bulkDeactivateActivationsResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type bulkDeactivateActivationsResponseSuccess = (bulkDeactivateActivationsResponse200) & {
  headers: Headers;
};
export type bulkDeactivateActivationsResponseError = (bulkDeactivateActivationsResponse400 | bulkDeactivateActivationsResponse401 | bulkDeactivateActivationsResponse403 | bulkDeactivateActivationsResponse503) & {
  headers: Headers;
};

export type bulkDeactivateActivationsResponse = (bulkDeactivateActivationsResponseSuccess | bulkDeactivateActivationsResponseError)

export const getBulkDeactivateActivationsUrl = () => {

  return `/v1/admin/activations/bulk-deactivate`
}

export const bulkDeactivateActivations = async (bulkActivationMutationRequest: BulkActivationMutationRequest, options?: RequestInit): Promise<bulkDeactivateActivationsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<bulkDeactivateActivationsResponse>(getBulkDeactivateActivationsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkActivationMutationRequest)
  }
);}

export type getProductUsageSnapshotResponse200 = {
  data: ProductUsageSnapshotResponse
  status: 200
}

export type getProductUsageSnapshotResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type getProductUsageSnapshotResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type getProductUsageSnapshotResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type getProductUsageSnapshotResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type getProductUsageSnapshotResponseSuccess = (getProductUsageSnapshotResponse200) & {
  headers: Headers;
};
export type getProductUsageSnapshotResponseError = (getProductUsageSnapshotResponse400 | getProductUsageSnapshotResponse401 | getProductUsageSnapshotResponse403 | getProductUsageSnapshotResponse503) & {
  headers: Headers;
};

export type getProductUsageSnapshotResponse = (getProductUsageSnapshotResponseSuccess | getProductUsageSnapshotResponseError)

export const getGetProductUsageSnapshotUrl = (params?: GetProductUsageSnapshotParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/analytics/product-usage?${stringifiedParams}` : `/v1/admin/analytics/product-usage`
}

/**
 * Returns a bounded Product Usage Snapshot. Paid and Trial classification is derived from durable License kind. Combined exposes only shared device-activity metrics.
 */
export const getProductUsageSnapshot = async (params?: GetProductUsageSnapshotParams, options?: RequestInit): Promise<getProductUsageSnapshotResponse> => {

  return adminFetch<getProductUsageSnapshotResponse>(getGetProductUsageSnapshotUrl(params),
  {
    ...options,
    method: 'GET'

  }
);}

export type getProductPlatformDistributionResponse200 = {
  data: ProductPlatformDistributionResponse
  status: 200
}

export type getProductPlatformDistributionResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type getProductPlatformDistributionResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type getProductPlatformDistributionResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type getProductPlatformDistributionResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type getProductPlatformDistributionResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type getProductPlatformDistributionResponseSuccess = (getProductPlatformDistributionResponse200) & {
  headers: Headers;
};
export type getProductPlatformDistributionResponseError = (getProductPlatformDistributionResponse400 | getProductPlatformDistributionResponse401 | getProductPlatformDistributionResponse403 | getProductPlatformDistributionResponse404 | getProductPlatformDistributionResponse503) & {
  headers: Headers;
};

export type getProductPlatformDistributionResponse = (getProductPlatformDistributionResponseSuccess | getProductPlatformDistributionResponseError)

export const getGetProductPlatformDistributionUrl = (productId: string,
    params?: GetProductPlatformDistributionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/analytics/products/${productId}/platform-distribution?${stringifiedParams}` : `/v1/admin/analytics/products/${productId}/platform-distribution`
}

export const getProductPlatformDistribution = async (productId: string,
    params?: GetProductPlatformDistributionParams, options?: RequestInit): Promise<getProductPlatformDistributionResponse> => {

  return adminFetch<getProductPlatformDistributionResponse>(getGetProductPlatformDistributionUrl(productId,params),
  {
    ...options,
    method: 'GET'

  }
);}

export type getProductAppVersionDistributionResponse200 = {
  data: ProductAppVersionDistributionResponse
  status: 200
}

export type getProductAppVersionDistributionResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type getProductAppVersionDistributionResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type getProductAppVersionDistributionResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type getProductAppVersionDistributionResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type getProductAppVersionDistributionResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type getProductAppVersionDistributionResponseSuccess = (getProductAppVersionDistributionResponse200) & {
  headers: Headers;
};
export type getProductAppVersionDistributionResponseError = (getProductAppVersionDistributionResponse400 | getProductAppVersionDistributionResponse401 | getProductAppVersionDistributionResponse403 | getProductAppVersionDistributionResponse404 | getProductAppVersionDistributionResponse503) & {
  headers: Headers;
};

export type getProductAppVersionDistributionResponse = (getProductAppVersionDistributionResponseSuccess | getProductAppVersionDistributionResponseError)

export const getGetProductAppVersionDistributionUrl = (productId: string,
    params?: GetProductAppVersionDistributionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/analytics/products/${productId}/app-version-distribution?${stringifiedParams}` : `/v1/admin/analytics/products/${productId}/app-version-distribution`
}

export const getProductAppVersionDistribution = async (productId: string,
    params?: GetProductAppVersionDistributionParams, options?: RequestInit): Promise<getProductAppVersionDistributionResponse> => {

  return adminFetch<getProductAppVersionDistributionResponse>(getGetProductAppVersionDistributionUrl(productId,params),
  {
    ...options,
    method: 'GET'

  }
);}

export type getProductLifecycleTrendResponse200 = {
  data: ProductLifecycleTrendResponse
  status: 200
}

export type getProductLifecycleTrendResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type getProductLifecycleTrendResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type getProductLifecycleTrendResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type getProductLifecycleTrendResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type getProductLifecycleTrendResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type getProductLifecycleTrendResponseSuccess = (getProductLifecycleTrendResponse200) & {
  headers: Headers;
};
export type getProductLifecycleTrendResponseError = (getProductLifecycleTrendResponse400 | getProductLifecycleTrendResponse401 | getProductLifecycleTrendResponse403 | getProductLifecycleTrendResponse404 | getProductLifecycleTrendResponse503) & {
  headers: Headers;
};

export type getProductLifecycleTrendResponse = (getProductLifecycleTrendResponseSuccess | getProductLifecycleTrendResponseError)

export const getGetProductLifecycleTrendUrl = (productId: string,
    params?: GetProductLifecycleTrendParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/analytics/products/${productId}/lifecycle-trend?${stringifiedParams}` : `/v1/admin/analytics/products/${productId}/lifecycle-trend`
}

export const getProductLifecycleTrend = async (productId: string,
    params?: GetProductLifecycleTrendParams, options?: RequestInit): Promise<getProductLifecycleTrendResponse> => {

  return adminFetch<getProductLifecycleTrendResponse>(getGetProductLifecycleTrendUrl(productId,params),
  {
    ...options,
    method: 'GET'

  }
);}

export type listProductsResponse200 = {
  data: ProductListResponse
  status: 200
}

export type listProductsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type listProductsResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type listProductsResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type listProductsResponseSuccess = (listProductsResponse200) & {
  headers: Headers;
};
export type listProductsResponseError = (listProductsResponse401 | listProductsResponse403 | listProductsResponse503) & {
  headers: Headers;
};

export type listProductsResponse = (listProductsResponseSuccess | listProductsResponseError)

export const getListProductsUrl = () => {

  return `/v1/products`
}

export const listProducts = async ( options?: RequestInit): Promise<listProductsResponse> => {

  return adminFetch<listProductsResponse>(getListProductsUrl(),
  {
    ...options,
    method: 'GET'

  }
);}

export type createProductResponse201 = {
  data: ProductResponse
  status: 201
}

export type createProductResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type createProductResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type createProductResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type createProductResponse409 = {
  data: ConflictResponse
  status: 409
}

export type createProductResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type createProductResponseSuccess = (createProductResponse201) & {
  headers: Headers;
};
export type createProductResponseError = (createProductResponse400 | createProductResponse401 | createProductResponse403 | createProductResponse409 | createProductResponse503) & {
  headers: Headers;
};

export type createProductResponse = (createProductResponseSuccess | createProductResponseError)

export const getCreateProductUrl = () => {

  return `/v1/products`
}

export const createProduct = async (productRequest: ProductRequest, options?: RequestInit): Promise<createProductResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<createProductResponse>(getCreateProductUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productRequest)
  }
);}

export type getProductResponse200 = {
  data: ProductResponse
  status: 200
}

export type getProductResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type getProductResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type getProductResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type getProductResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type getProductResponseSuccess = (getProductResponse200) & {
  headers: Headers;
};
export type getProductResponseError = (getProductResponse401 | getProductResponse403 | getProductResponse404 | getProductResponse503) & {
  headers: Headers;
};

export type getProductResponse = (getProductResponseSuccess | getProductResponseError)

export const getGetProductUrl = (productId: string,) => {

  return `/v1/products/${productId}`
}

export const getProduct = async (productId: string, options?: RequestInit): Promise<getProductResponse> => {

  return adminFetch<getProductResponse>(getGetProductUrl(productId),
  {
    ...options,
    method: 'GET'

  }
);}

export type updateProductStatusResponse200 = {
  data: ProductResponse
  status: 200
}

export type updateProductStatusResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type updateProductStatusResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type updateProductStatusResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type updateProductStatusResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type updateProductStatusResponse409 = {
  data: ConflictResponse
  status: 409
}

export type updateProductStatusResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type updateProductStatusResponseSuccess = (updateProductStatusResponse200) & {
  headers: Headers;
};
export type updateProductStatusResponseError = (updateProductStatusResponse400 | updateProductStatusResponse401 | updateProductStatusResponse403 | updateProductStatusResponse404 | updateProductStatusResponse409 | updateProductStatusResponse503) & {
  headers: Headers;
};

export type updateProductStatusResponse = (updateProductStatusResponseSuccess | updateProductStatusResponseError)

export const getUpdateProductStatusUrl = (productId: string,) => {

  return `/v1/products/${productId}/status`
}

export const updateProductStatus = async (productId: string,
    productStatusRequest: ProductStatusRequest, options?: RequestInit): Promise<updateProductStatusResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<updateProductStatusResponse>(getUpdateProductStatusUrl(productId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productStatusRequest)
  }
);}

export type updateProductFeatureCatalogResponse200 = {
  data: ProductResponse
  status: 200
}

export type updateProductFeatureCatalogResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type updateProductFeatureCatalogResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type updateProductFeatureCatalogResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type updateProductFeatureCatalogResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type updateProductFeatureCatalogResponse409 = {
  data: ConflictResponse
  status: 409
}

export type updateProductFeatureCatalogResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type updateProductFeatureCatalogResponseSuccess = (updateProductFeatureCatalogResponse200) & {
  headers: Headers;
};
export type updateProductFeatureCatalogResponseError = (updateProductFeatureCatalogResponse400 | updateProductFeatureCatalogResponse401 | updateProductFeatureCatalogResponse403 | updateProductFeatureCatalogResponse404 | updateProductFeatureCatalogResponse409 | updateProductFeatureCatalogResponse503) & {
  headers: Headers;
};

export type updateProductFeatureCatalogResponse = (updateProductFeatureCatalogResponseSuccess | updateProductFeatureCatalogResponseError)

export const getUpdateProductFeatureCatalogUrl = (productId: string,) => {

  return `/v1/products/${productId}/feature-catalog`
}

export const updateProductFeatureCatalog = async (productId: string,
    productFeatureCatalogRequest: ProductFeatureCatalogRequest, options?: RequestInit): Promise<updateProductFeatureCatalogResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<updateProductFeatureCatalogResponse>(getUpdateProductFeatureCatalogUrl(productId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productFeatureCatalogRequest)
  }
);}

export type exportIntegrationGuideResponse200 = {
  data: Blob
  status: 200
}

export type exportIntegrationGuideResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type exportIntegrationGuideResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type exportIntegrationGuideResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type exportIntegrationGuideResponseSuccess = (exportIntegrationGuideResponse200) & {
  headers: Headers;
};
export type exportIntegrationGuideResponseError = (exportIntegrationGuideResponse401 | exportIntegrationGuideResponse403 | exportIntegrationGuideResponse503) & {
  headers: Headers;
};

export type exportIntegrationGuideResponse = (exportIntegrationGuideResponseSuccess | exportIntegrationGuideResponseError)

export const getExportIntegrationGuideUrl = () => {

  return `/v1/integration-guide/export`
}

export const exportIntegrationGuide = async ( options?: RequestInit): Promise<exportIntegrationGuideResponse> => {

  return adminFetch<exportIntegrationGuideResponse>(getExportIntegrationGuideUrl(),
  {
    ...options,
    method: 'POST'

  }
);}

export type listCustomersResponse200 = {
  data: CustomerListResponse
  status: 200
}

export type listCustomersResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type listCustomersResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type listCustomersResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type listCustomersResponseSuccess = (listCustomersResponse200) & {
  headers: Headers;
};
export type listCustomersResponseError = (listCustomersResponse401 | listCustomersResponse403 | listCustomersResponse503) & {
  headers: Headers;
};

export type listCustomersResponse = (listCustomersResponseSuccess | listCustomersResponseError)

export const getListCustomersUrl = () => {

  return `/v1/customers`
}

export const listCustomers = async ( options?: RequestInit): Promise<listCustomersResponse> => {

  return adminFetch<listCustomersResponse>(getListCustomersUrl(),
  {
    ...options,
    method: 'GET'

  }
);}

export type createCustomerResponse201 = {
  data: CustomerResponse
  status: 201
}

export type createCustomerResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type createCustomerResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type createCustomerResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type createCustomerResponseSuccess = (createCustomerResponse201) & {
  headers: Headers;
};
export type createCustomerResponseError = (createCustomerResponse401 | createCustomerResponse403 | createCustomerResponse503) & {
  headers: Headers;
};

export type createCustomerResponse = (createCustomerResponseSuccess | createCustomerResponseError)

export const getCreateCustomerUrl = () => {

  return `/v1/customers`
}

export const createCustomer = async (customerRequest: CustomerRequest, options?: RequestInit): Promise<createCustomerResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<createCustomerResponse>(getCreateCustomerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(customerRequest)
  }
);}

export type getCustomerResponse200 = {
  data: CustomerResponse
  status: 200
}

export type getCustomerResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type getCustomerResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type getCustomerResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type getCustomerResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type getCustomerResponseSuccess = (getCustomerResponse200) & {
  headers: Headers;
};
export type getCustomerResponseError = (getCustomerResponse401 | getCustomerResponse403 | getCustomerResponse404 | getCustomerResponse503) & {
  headers: Headers;
};

export type getCustomerResponse = (getCustomerResponseSuccess | getCustomerResponseError)

export const getGetCustomerUrl = (customerId: string,) => {

  return `/v1/customers/${customerId}`
}

export const getCustomer = async (customerId: string, options?: RequestInit): Promise<getCustomerResponse> => {

  return adminFetch<getCustomerResponse>(getGetCustomerUrl(customerId),
  {
    ...options,
    method: 'GET'

  }
);}

export type listLicensesResponse200 = {
  data: LicenseListResponse
  status: 200
}

export type listLicensesResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type listLicensesResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type listLicensesResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type listLicensesResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type listLicensesResponseSuccess = (listLicensesResponse200) & {
  headers: Headers;
};
export type listLicensesResponseError = (listLicensesResponse400 | listLicensesResponse401 | listLicensesResponse403 | listLicensesResponse503) & {
  headers: Headers;
};

export type listLicensesResponse = (listLicensesResponseSuccess | listLicensesResponseError)

export const getListLicensesUrl = (params?: ListLicensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/licenses?${stringifiedParams}` : `/v1/licenses`
}

export const listLicenses = async (params?: ListLicensesParams, options?: RequestInit): Promise<listLicensesResponse> => {

  return adminFetch<listLicensesResponse>(getListLicensesUrl(params),
  {
    ...options,
    method: 'GET'

  }
);}

export type createLicenseResponse201 = {
  data: LicenseResponse
  status: 201
}

export type createLicenseResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type createLicenseResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type createLicenseResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type createLicenseResponseSuccess = (createLicenseResponse201) & {
  headers: Headers;
};
export type createLicenseResponseError = (createLicenseResponse401 | createLicenseResponse403 | createLicenseResponse503) & {
  headers: Headers;
};

export type createLicenseResponse = (createLicenseResponseSuccess | createLicenseResponseError)

export const getCreateLicenseUrl = () => {

  return `/v1/licenses`
}

export const createLicense = async (licenseRequest: LicenseRequest, options?: RequestInit): Promise<createLicenseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<createLicenseResponse>(getCreateLicenseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(licenseRequest)
  }
);}

export type updateLicenseResponse200 = {
  data: LicenseResponse
  status: 200
}

export type updateLicenseResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type updateLicenseResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type updateLicenseResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type updateLicenseResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type updateLicenseResponseSuccess = (updateLicenseResponse200) & {
  headers: Headers;
};
export type updateLicenseResponseError = (updateLicenseResponse401 | updateLicenseResponse403 | updateLicenseResponse404 | updateLicenseResponse503) & {
  headers: Headers;
};

export type updateLicenseResponse = (updateLicenseResponseSuccess | updateLicenseResponseError)

export const getUpdateLicenseUrl = (licenseId: string,) => {

  return `/v1/licenses/${licenseId}`
}

export const updateLicense = async (licenseId: string,
    licensePatchRequest: LicensePatchRequest, options?: RequestInit): Promise<updateLicenseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<updateLicenseResponse>(getUpdateLicenseUrl(licenseId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(licensePatchRequest)
  }
);}

export type promoteLicenseResponse200 = {
  data: LicenseResponse
  status: 200
}

export type promoteLicenseResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type promoteLicenseResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type promoteLicenseResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type promoteLicenseResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type promoteLicenseResponse409 = {
  data: ConflictResponse
  status: 409
}

export type promoteLicenseResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type promoteLicenseResponseSuccess = (promoteLicenseResponse200) & {
  headers: Headers;
};
export type promoteLicenseResponseError = (promoteLicenseResponse400 | promoteLicenseResponse401 | promoteLicenseResponse403 | promoteLicenseResponse404 | promoteLicenseResponse409 | promoteLicenseResponse503) & {
  headers: Headers;
};

export type promoteLicenseResponse = (promoteLicenseResponseSuccess | promoteLicenseResponseError)

export const getPromoteLicenseUrl = (licenseId: string,) => {

  return `/v1/licenses/${licenseId}/promote`
}

export const promoteLicense = async (licenseId: string,
    promoteLicenseRequest: PromoteLicenseRequest, options?: RequestInit): Promise<promoteLicenseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<promoteLicenseResponse>(getPromoteLicenseUrl(licenseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(promoteLicenseRequest)
  }
);}

export type issueProductKeysResponse201 = {
  data: KeyBatchResponse
  status: 201
}

export type issueProductKeysResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type issueProductKeysResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type issueProductKeysResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type issueProductKeysResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type issueProductKeysResponse409 = {
  data: ConflictResponse
  status: 409
}

export type issueProductKeysResponse429 = {
  data: TooManyRequestsResponse
  status: 429
}

export type issueProductKeysResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type issueProductKeysResponseSuccess = (issueProductKeysResponse201) & {
  headers: Headers;
};
export type issueProductKeysResponseError = (issueProductKeysResponse400 | issueProductKeysResponse401 | issueProductKeysResponse403 | issueProductKeysResponse404 | issueProductKeysResponse409 | issueProductKeysResponse429 | issueProductKeysResponse503) & {
  headers: Headers;
};

export type issueProductKeysResponse = (issueProductKeysResponseSuccess | issueProductKeysResponseError)

export const getIssueProductKeysUrl = () => {

  return `/v1/license-key-batches`
}

export const issueProductKeys = async (keyBatchRequest: KeyBatchRequest, options?: RequestInit): Promise<issueProductKeysResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<issueProductKeysResponse>(getIssueProductKeysUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(keyBatchRequest)
  }
);}

export type revokeLicenseResponse200 = {
  data: LicenseResponse
  status: 200
}

export type revokeLicenseResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type revokeLicenseResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type revokeLicenseResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type revokeLicenseResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type revokeLicenseResponseSuccess = (revokeLicenseResponse200) & {
  headers: Headers;
};
export type revokeLicenseResponseError = (revokeLicenseResponse401 | revokeLicenseResponse403 | revokeLicenseResponse404 | revokeLicenseResponse503) & {
  headers: Headers;
};

export type revokeLicenseResponse = (revokeLicenseResponseSuccess | revokeLicenseResponseError)

export const getRevokeLicenseUrl = (licenseId: string,) => {

  return `/v1/licenses/${licenseId}/revoke`
}

export const revokeLicense = async (licenseId: string,
    reasonRequest: ReasonRequest, options?: RequestInit): Promise<revokeLicenseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<revokeLicenseResponse>(getRevokeLicenseUrl(licenseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reasonRequest)
  }
);}

export type listActivationsResponse200 = {
  data: ActivationsResponse
  status: 200
}

export type listActivationsResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type listActivationsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type listActivationsResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type listActivationsResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type listActivationsResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type listActivationsResponseSuccess = (listActivationsResponse200) & {
  headers: Headers;
};
export type listActivationsResponseError = (listActivationsResponse400 | listActivationsResponse401 | listActivationsResponse403 | listActivationsResponse404 | listActivationsResponse503) & {
  headers: Headers;
};

export type listActivationsResponse = (listActivationsResponseSuccess | listActivationsResponseError)

export const getListActivationsUrl = (licenseId: string,
    params?: ListActivationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/licenses/${licenseId}/activations?${stringifiedParams}` : `/v1/licenses/${licenseId}/activations`
}

export const listActivations = async (licenseId: string,
    params?: ListActivationsParams, options?: RequestInit): Promise<listActivationsResponse> => {

  return adminFetch<listActivationsResponse>(getListActivationsUrl(licenseId,params),
  {
    ...options,
    method: 'GET'

  }
);}

export type generateDeliveryPackPDFResponse200 = {
  data: Blob
  status: 200
}

export type generateDeliveryPackPDFResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type generateDeliveryPackPDFResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type generateDeliveryPackPDFResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type generateDeliveryPackPDFResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type generateDeliveryPackPDFResponse429 = {
  data: TooManyRequestsResponse
  status: 429
}

export type generateDeliveryPackPDFResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type generateDeliveryPackPDFResponseSuccess = (generateDeliveryPackPDFResponse200) & {
  headers: Headers;
};
export type generateDeliveryPackPDFResponseError = (generateDeliveryPackPDFResponse400 | generateDeliveryPackPDFResponse401 | generateDeliveryPackPDFResponse403 | generateDeliveryPackPDFResponse404 | generateDeliveryPackPDFResponse429 | generateDeliveryPackPDFResponse503) & {
  headers: Headers;
};

export type generateDeliveryPackPDFResponse = (generateDeliveryPackPDFResponseSuccess | generateDeliveryPackPDFResponseError)

export const getGenerateDeliveryPackPDFUrl = (licenseId: string,) => {

  return `/v1/licenses/${licenseId}/delivery-pack-pdf`
}

/**
 * License Manager or Security Admin creates an English-only, in-memory delivery-card PDF from an issued batch. Full Product Keys are accepted only from the current browser-memory issuance result and exist only in the no-store response bytes; they are never logged, persisted, audited, or replayed. At most two renders per process; excess requests return 503 for retry.
 */
export const generateDeliveryPackPDF = async (licenseId: string,
    deliveryPackPDFRequest: DeliveryPackPDFRequest, options?: RequestInit): Promise<generateDeliveryPackPDFResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<generateDeliveryPackPDFResponse>(getGenerateDeliveryPackPDFUrl(licenseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deliveryPackPDFRequest)
  }
);}

export type recordDeliveryPackExportResponse201 = {
  data: DeliveryPackExportResponse
  status: 201
}

export type recordDeliveryPackExportResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type recordDeliveryPackExportResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type recordDeliveryPackExportResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type recordDeliveryPackExportResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type recordDeliveryPackExportResponseSuccess = (recordDeliveryPackExportResponse201) & {
  headers: Headers;
};
export type recordDeliveryPackExportResponseError = (recordDeliveryPackExportResponse400 | recordDeliveryPackExportResponse401 | recordDeliveryPackExportResponse403 | recordDeliveryPackExportResponse404) & {
  headers: Headers;
};

export type recordDeliveryPackExportResponse = (recordDeliveryPackExportResponseSuccess | recordDeliveryPackExportResponseError)

export const getRecordDeliveryPackExportUrl = (licenseId: string,) => {

  return `/v1/licenses/${licenseId}/delivery-pack-exports`
}

export const recordDeliveryPackExport = async (licenseId: string,
    deliveryPackExportRequest: DeliveryPackExportRequest, options?: RequestInit): Promise<recordDeliveryPackExportResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<recordDeliveryPackExportResponse>(getRecordDeliveryPackExportUrl(licenseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deliveryPackExportRequest)
  }
);}

export type listProductKeysResponse200 = {
  data: ProductKeysResponse
  status: 200
}

export type listProductKeysResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type listProductKeysResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type listProductKeysResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type listProductKeysResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type listProductKeysResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type listProductKeysResponseSuccess = (listProductKeysResponse200) & {
  headers: Headers;
};
export type listProductKeysResponseError = (listProductKeysResponse400 | listProductKeysResponse401 | listProductKeysResponse403 | listProductKeysResponse404 | listProductKeysResponse503) & {
  headers: Headers;
};

export type listProductKeysResponse = (listProductKeysResponseSuccess | listProductKeysResponseError)

export const getListProductKeysUrl = (licenseId: string,
    params?: ListProductKeysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/licenses/${licenseId}/product-keys?${stringifiedParams}` : `/v1/licenses/${licenseId}/product-keys`
}

export const listProductKeys = async (licenseId: string,
    params?: ListProductKeysParams, options?: RequestInit): Promise<listProductKeysResponse> => {

  return adminFetch<listProductKeysResponse>(getListProductKeysUrl(licenseId,params),
  {
    ...options,
    method: 'GET'

  }
);}

export type reduceSeatLimitResponse200 = {
  data: LicenseResponse
  status: 200
}

export type reduceSeatLimitResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type reduceSeatLimitResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type reduceSeatLimitResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type reduceSeatLimitResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type reduceSeatLimitResponse409 = {
  data: ConflictResponse
  status: 409
}

export type reduceSeatLimitResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type reduceSeatLimitResponseSuccess = (reduceSeatLimitResponse200) & {
  headers: Headers;
};
export type reduceSeatLimitResponseError = (reduceSeatLimitResponse400 | reduceSeatLimitResponse401 | reduceSeatLimitResponse403 | reduceSeatLimitResponse404 | reduceSeatLimitResponse409 | reduceSeatLimitResponse503) & {
  headers: Headers;
};

export type reduceSeatLimitResponse = (reduceSeatLimitResponseSuccess | reduceSeatLimitResponseError)

export const getReduceSeatLimitUrl = (licenseId: string,) => {

  return `/v1/licenses/${licenseId}/seat-limit-reduction`
}

export const reduceSeatLimit = async (licenseId: string,
    seatLimitReductionRequest: SeatLimitReductionRequest, options?: RequestInit): Promise<reduceSeatLimitResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<reduceSeatLimitResponse>(getReduceSeatLimitUrl(licenseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(seatLimitReductionRequest)
  }
);}

export type replaceProductKeyResponse200 = {
  data: ProductKeyReplacementResponse
  status: 200
}

export type replaceProductKeyResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type replaceProductKeyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type replaceProductKeyResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type replaceProductKeyResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type replaceProductKeyResponse409 = {
  data: ConflictResponse
  status: 409
}

export type replaceProductKeyResponse429 = {
  data: TooManyRequestsResponse
  status: 429
}

export type replaceProductKeyResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type replaceProductKeyResponseSuccess = (replaceProductKeyResponse200) & {
  headers: Headers;
};
export type replaceProductKeyResponseError = (replaceProductKeyResponse400 | replaceProductKeyResponse401 | replaceProductKeyResponse403 | replaceProductKeyResponse404 | replaceProductKeyResponse409 | replaceProductKeyResponse429 | replaceProductKeyResponse503) & {
  headers: Headers;
};

export type replaceProductKeyResponse = (replaceProductKeyResponseSuccess | replaceProductKeyResponseError)

export const getReplaceProductKeyUrl = (licenseId: string,
    keyId: string,) => {

  return `/v1/licenses/${licenseId}/product-keys/${keyId}/replace`
}

export const replaceProductKey = async (licenseId: string,
    keyId: string,
    reasonRequest: ReasonRequest, options?: RequestInit): Promise<replaceProductKeyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<replaceProductKeyResponse>(getReplaceProductKeyUrl(licenseId,keyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reasonRequest)
  }
);}

export type revokeProductKeyResponse200 = {
  data: ProductKeyResponse
  status: 200
}

export type revokeProductKeyResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type revokeProductKeyResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type revokeProductKeyResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type revokeProductKeyResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type revokeProductKeyResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type revokeProductKeyResponseSuccess = (revokeProductKeyResponse200) & {
  headers: Headers;
};
export type revokeProductKeyResponseError = (revokeProductKeyResponse400 | revokeProductKeyResponse401 | revokeProductKeyResponse403 | revokeProductKeyResponse404 | revokeProductKeyResponse503) & {
  headers: Headers;
};

export type revokeProductKeyResponse = (revokeProductKeyResponseSuccess | revokeProductKeyResponseError)

export const getRevokeProductKeyUrl = (keyId: string,) => {

  return `/v1/product-keys/${keyId}/revoke`
}

export const revokeProductKey = async (keyId: string,
    reasonRequest: ReasonRequest, options?: RequestInit): Promise<revokeProductKeyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<revokeProductKeyResponse>(getRevokeProductKeyUrl(keyId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(reasonRequest)
  }
);}

export type listLicenseTimelineResponse200 = {
  data: TimelineResponse
  status: 200
}

export type listLicenseTimelineResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type listLicenseTimelineResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type listLicenseTimelineResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type listLicenseTimelineResponse404 = {
  data: NotFoundResponse
  status: 404
}

export type listLicenseTimelineResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type listLicenseTimelineResponseSuccess = (listLicenseTimelineResponse200) & {
  headers: Headers;
};
export type listLicenseTimelineResponseError = (listLicenseTimelineResponse400 | listLicenseTimelineResponse401 | listLicenseTimelineResponse403 | listLicenseTimelineResponse404 | listLicenseTimelineResponse503) & {
  headers: Headers;
};

export type listLicenseTimelineResponse = (listLicenseTimelineResponseSuccess | listLicenseTimelineResponseError)

export const getListLicenseTimelineUrl = (licenseId: string,
    params?: ListLicenseTimelineParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/licenses/${licenseId}/timeline?${stringifiedParams}` : `/v1/licenses/${licenseId}/timeline`
}

export const listLicenseTimeline = async (licenseId: string,
    params?: ListLicenseTimelineParams, options?: RequestInit): Promise<listLicenseTimelineResponse> => {

  return adminFetch<listLicenseTimelineResponse>(getListLicenseTimelineUrl(licenseId,params),
  {
    ...options,
    method: 'GET'

  }
);}

export type listAuditEventsResponse200 = {
  data: AuditResponse
  status: 200
}

export type listAuditEventsResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type listAuditEventsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type listAuditEventsResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type listAuditEventsResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type listAuditEventsResponseSuccess = (listAuditEventsResponse200) & {
  headers: Headers;
};
export type listAuditEventsResponseError = (listAuditEventsResponse400 | listAuditEventsResponse401 | listAuditEventsResponse403 | listAuditEventsResponse503) & {
  headers: Headers;
};

export type listAuditEventsResponse = (listAuditEventsResponseSuccess | listAuditEventsResponseError)

export const getListAuditEventsUrl = (params?: ListAuditEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/audit-events?${stringifiedParams}` : `/v1/audit-events`
}

/**
 * Newest-first cursor pages. IP addresses are masked for every role except Security Admin, and only Security Admin may filter by ip.
 */
export const listAuditEvents = async (params?: ListAuditEventsParams, options?: RequestInit): Promise<listAuditEventsResponse> => {

  return adminFetch<listAuditEventsResponse>(getListAuditEventsUrl(params),
  {
    ...options,
    method: 'GET'

  }
);}

export type exportAuditEventsResponse200 = {
  data: Blob
  status: 200
}

export type exportAuditEventsResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type exportAuditEventsResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type exportAuditEventsResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type exportAuditEventsResponse422 = {
  data: ErrorResponse
  status: 422
}

export type exportAuditEventsResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type exportAuditEventsResponseSuccess = (exportAuditEventsResponse200) & {
  headers: Headers;
};
export type exportAuditEventsResponseError = (exportAuditEventsResponse400 | exportAuditEventsResponse401 | exportAuditEventsResponse403 | exportAuditEventsResponse422 | exportAuditEventsResponse503) & {
  headers: Headers;
};

export type exportAuditEventsResponse = (exportAuditEventsResponseSuccess | exportAuditEventsResponseError)

export const getExportAuditEventsUrl = () => {

  return `/v1/audit-events/export`
}

/**
 * Appends audit.exported before any bytes are returned; no file is returned when that audit fails. IP masking and the ip filter follow listAuditEvents. More than 10000 matching events returns 422 audit_export_too_large.
 * @summary Export every Audit event matching the filters as CSV
 */
export const exportAuditEvents = async (auditExportRequest: AuditExportRequest, options?: RequestInit): Promise<exportAuditEventsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return adminFetch<exportAuditEventsResponse>(getExportAuditEventsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(auditExportRequest)
  }
);}

export type searchAdminEntitiesResponse200 = {
  data: SearchResponse
  status: 200
}

export type searchAdminEntitiesResponse400 = {
  data: BadRequestResponse
  status: 400
}

export type searchAdminEntitiesResponse401 = {
  data: UnauthorizedResponse
  status: 401
}

export type searchAdminEntitiesResponse403 = {
  data: ForbiddenResponse
  status: 403
}

export type searchAdminEntitiesResponse503 = {
  data: ServiceUnavailableResponse
  status: 503
}

export type searchAdminEntitiesResponseSuccess = (searchAdminEntitiesResponse200) & {
  headers: Headers;
};
export type searchAdminEntitiesResponseError = (searchAdminEntitiesResponse400 | searchAdminEntitiesResponse401 | searchAdminEntitiesResponse403 | searchAdminEntitiesResponse503) & {
  headers: Headers;
};

export type searchAdminEntitiesResponse = (searchAdminEntitiesResponseSuccess | searchAdminEntitiesResponseError)

export const getSearchAdminEntitiesUrl = (params: SearchAdminEntitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/search?${stringifiedParams}` : `/v1/search`
}

export const searchAdminEntities = async (params: SearchAdminEntitiesParams, options?: RequestInit): Promise<searchAdminEntitiesResponse> => {

  return adminFetch<searchAdminEntitiesResponse>(getSearchAdminEntitiesUrl(params),
  {
    ...options,
    method: 'GET'

  }
);}
